function parseAddress(address) {
  // console.log(address);
  if (!address) {
    return { city: '', province: '', country: '' };
  }
  const cityTypes = 'city|town|village|hamlet|suburb|island|county'.split('|');
  const cityType = cityTypes.find(type => address[type]);
  return {
    city: address[cityType],
    province: address.state || address.county,
    country: address.country,
  };
}

export default parseAddress;
